/*
 * 展示页面
 *
 * @Author: xiaoJQ
 * @Date: 2024-05-15 16:25:35
 *
 * Copyright © 2024 kingdee.com. All Rights Reserved.
 */
import React, { useCallback, useState } from 'react';
import InfoList from 'components/infoList';
import CanvasList from 'components/canvasList';
import Styles from './index.less';
export default function DisplayPage() {
    var _a = useState({ extractId: '', type: '' }), selected = _a[0], setSelected = _a[1];
    var handleSaveExtractId = useCallback(function (extractId, type) {
        setSelected({ extractId: extractId, type: type });
    }, []);
    return (React.createElement("div", { className: Styles.displayPage },
        React.createElement(CanvasList, { scrollData: selected, handleSelectRectItem: handleSaveExtractId }),
        React.createElement(InfoList, { handleSelectListItem: handleSaveExtractId })));
}
